import { render, staticRenderFns } from "./CollectionCover.vue?vue&type=template&id=ed2d700e&scoped=true"
import script from "./CollectionCover.vue?vue&type=script&lang=js"
export * from "./CollectionCover.vue?vue&type=script&lang=js"
import style0 from "./CollectionCover.vue?vue&type=style&index=0&id=ed2d700e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2d700e",
  null
  
)

export default component.exports